import React from "react";
import { DialogHeader, DialogBody } from "components/common/dialogs/GenericDialog";
import { useLocale } from "lib/hooks/useLocale";
import PrimaryButton from "components/common/buttons/PrimaryButton";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { X } from "@phosphor-icons/react";

interface ReplaceCouponDialogProps {
  setIsOpen: () => void;
  applyCoupon: () => void;
}

const ReplaceCouponDialog: React.FC<ReplaceCouponDialogProps> = ({ setIsOpen, applyCoupon }) => {
  const { t } = useLocale();
  const {
    state: { appliedCoupons },
  } = useCheckoutContext();

  return (
    <>
      <DialogHeader>
        <div className="flex h-full w-full flex-row items-center justify-between">
          <h1 className="text-base font-medium">
            {" "}
            {t("replace_coupon_header", { count: appliedCoupons?.length })}
          </h1>
          <button className="outline-none">
            <X className="h-5 w-5 cursor-pointer text-coal-dark" onClick={() => setIsOpen()} />
          </button>
        </div>
      </DialogHeader>

      <DialogBody>
        <div className="relative flex w-full flex-col space-y-6 px-6 pt-4 pb-8">
          <p className="text-sm text-coal-dark">
            {t("replace_coupon_body", { count: appliedCoupons?.length })}
          </p>
          <PrimaryButton
            buttonText={t("continue")}
            onClick={applyCoupon}
            height="h-14"
            isLoading={false}
            isDisabled={false}
          />
        </div>
      </DialogBody>
    </>
  );
};

export default ReplaceCouponDialog;
